export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//Black or white, whichever has the higher WCAG contrast against the given "#rrggbb" background
export function getContrastTextColor(backgroundColor) {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const channel = parseInt(backgroundColor.slice(i, i + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  const contrastWithWhite = 1.05 / (luminance + 0.05);
  const contrastWithBlack = (luminance + 0.05) / 0.05;
  return contrastWithBlack >= contrastWithWhite ? "black" : "white";
}
